
    import MiezzPageList from "@/models/MiezzPageList";
    import CurrentLogier from "@/apis/CurrentLogier";
    import MiezzMonthChoose from "@/components/MiezzMonthChoose.vue";
    import { Vue, Options } from "vue-class-component";
    import { Emit, Model, Prop, Watch } from "vue-property-decorator";
    import { init, EChartsOption } from "echarts";
    import MiezzButton from "@/models/MiezzButton";
    import DtoRequestCount from "@/models.machine/DtoRequestCount";
    import DtoCallbackCount from "@/models.machine/DtoCallbackCount";
    import DtoCallbackComposition from "@/models.machine/DtoCallbackComposition";
    import FinanceAppService from "@/apis.machine/FinanceAppService";
    import DynamicSearchAppService from "@/apis.machine/DynamicSearchAppService";
    import { EnumRelation } from "@/models.machine/EnumRelation";
    import { EnumCompare } from "@/models.machine/EnumCompare";
    import DtoPageListSearchSaler, { DtoPageListSearchSalerDynamicSearchItems } from "@/models.machine/DtoPageListSearchSaler";
    import DtoPageListOverviewSaler from "@/models.machine/DtoPageListOverviewSaler";
    import DtoPageListItemOverviewSaler, {
        DtoPageListItemOverviewSalerMiezzListItems,
    } from "@/models.machine/DtoPageListItemOverviewSaler";
import DtoDetailCompanyCurrencySystem from "@/models.machine/DtoDetailCompanyCurrencySystem";
import CompanyAppService from "@/apis.machine/CompanyAppService";
import DtoOverviewCustomerBillRequest from "@/models.machine/DtoOverviewCustomerBillRequest";
import DtoOverviewCustomerBillResponseItem from "@/models.machine/DtoOverviewCustomerBillResponseItem";


    @Options({
        components: {
            MiezzMonthChoose,
        },
    })
    export default class FinanceStatOverView extends Vue {

        isGrossProfitChart = false;
        items = new MiezzPageList<DtoPageListSearchSaler, DtoPageListItemOverviewSaler, string>("FinancialManagement");
        items2 = new MiezzPageList<DtoOverviewCustomerBillRequest, DtoOverviewCustomerBillResponseItem, string>("FinancialManagement");
        settlementVisible = false;

        isStat = false;
        isLeft = false;
        isLoading = false;
        month?: string = "";
        type?: string = "0";
        detailForm: {
            Visible: boolean;
            Title: string;
            Items: any[];
            Details: any[];
            CurrentSystemId: string | undefined;
        } = {
                Visible: false,
                Title: "组成",
                Items: [],
                Details: [],
                CurrentSystemId: undefined,
            };
        grossProfitDetailForm: {
            Visible: boolean;
            Title: string;
            Items: any[];
        } = {
                Visible: false,
                Title: "组成",
                Items: [],
            };
        search: any[] = [];
        left: any[] = [];
        right: any[] = [];
        detailBottomButtons?: MiezzButton[] = [
            {
                //Icon: "select",
                IsBlue: true,
                Code: "submit",
                Label: "搜索相关账单",
                Type: "primary",
                Size: "small",
            },
            {
                //Icon:"CloseBold",
                IsBlue: true,
                Code: "close",
                Label: "关闭",
                Type: "default",
                Size: "small",
            },
        ];

        searchForm = {
            CustomerName :""
        }
        btnSearch:MiezzButton = {
                Code: "search",
                Label: "搜索",
                Type: "primary",
                Size: "small",
        }
        btnSearchReset:MiezzButton = {
                Code: "reset",
                Label: "重置",
                Type: "default",
                Size: "small",
        }

        grossProfitDetailBottomButtons?: MiezzButton[] = [
            {
                IsBlue: true,
                Code: "export",
                Label: "导出",
                Type: "primary",
                Size: "small",
            },
            {
                IsBlue: true,
                Code: "close",
                Label: "关闭",
                Type: "default",
                Size: "small",
            },
        ];

        settlementDetailBottomButtons?: MiezzButton[] = [
            {
                IsBlue: true,
                Code: "close",
                Label: "关闭",
                Type: "default",
                Size: "small",
            },
        ];

        FinancialManagement_StatisticalAnalysis_Overview = false;
        FinancialManagement_StatisticalAnalysis_SalespersonRelated = false;
        FinancialManagement_StatisticalAnalysis_CustomerRelated = false;

        FinancialManagement_StatisticalAnalysis_Overview_CollecionProgress = false;
        FinancialManagement_StatisticalAnalysis_Overview_PaymentProgress = false;
        FinancialManagement_StatisticalAnalysis_Overview_GrossProfit = false;
        FinancialManagement_StatisticalAnalysis_Overview_ActualProfit = false;
        FinancialManagement_StatisticalAnalysis_Overview_SalespersonPerformance = false;
        FinancialManagement_StatisticalAnalysis_Overview_CustomerPerformance = false;

        isFinancialCycle = false;
        result = new DtoCallbackCount();
        detail = new DtoCallbackComposition();
        isInit = true;
        currencySystem?:DtoDetailCompanyCurrencySystem;
        
    formatNumber = (num?: number) => {
        if (!num) return '';
        // 去除非数字字符（保留负号和小数点）
        const cleanNum = num.toString().replace(/[^\d.-]/g, '');
        // 分割整数和小数部分
        const parts = cleanNum.split('.');
        // 整数部分加千分位
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // 拼接整数和小数部分
        return parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];
    };

        async created(): Promise<void> {
    const res = await CompanyAppService.GetCurrencySystem();
    this.currencySystem = res.data.Data
            this.FinancialManagement_StatisticalAnalysis_Overview = false;
            this.FinancialManagement_StatisticalAnalysis_SalespersonRelated = false;
            this.FinancialManagement_StatisticalAnalysis_CustomerRelated = false;

            //列表-传参
            this.items.Dto = new DtoPageListSearchSaler();
            //列表-动态搜索-项
            this.items.DynamicSearchItems = DtoPageListSearchSalerDynamicSearchItems;
            //列表-数据-初始
            this.items.Data = new DtoPageListOverviewSaler();
            this.items.Fix = false;
            this.items.EnabledDynamicSearch = false;
            this.items.EnabledRadioSearch = false;
            this.items.EnabledRadioSearchAll = false;
            //this.items.Items = DtoListItemSalerMiezzListItems;
            //列表-列配置
            this.items.Items = [];
            var items = DtoPageListItemOverviewSalerMiezzListItems?.filter(it=> this.currencySystem?.ShowTaxRate == true?true: !it.Prop?.contains("TaxAmount"))
            ?.filter(it=> this.type != "5"?true: (it.Prop != "PaymentString" && it.Prop != "ActualString"))
            ?.map((it) => {
                const item = Object.copy(it);
                if (item.Prop == "PaymentString") {
                    item.CustomizeHeader = true;
                    return item;
                }
                else if (item.Prop == "SalerName" && this.type == "5") {
                    item.Label = "客户名称";
                    return item;
                }
                else {
                    return item;
                }

            });
            if (items && this.items.Items) {
                for (var it of items) {
                    if (it != undefined) {
                        this.items.Items.push(it);
                    }
                }
            }

            ////列表-行按钮
            //this.items.RowButtons = [
            //    {
            //        Code: "detail",
            //        Title: "查看详细",
            //        Icon: "search",
            //        Type: "default",
            //        Size: "small",
            //    },
            //];

            CurrentLogier.GetPowerCodes().then((r) => {
                if (r?.contains("FinancialManagement_StatisticalAnalysis_Overview")) {
                    this.FinancialManagement_StatisticalAnalysis_Overview = true;
                }
                if (
                    r?.contains(
                        "FinancialManagement_StatisticalAnalysis_SalespersonRelated"
                    )
                ) {
                    this.FinancialManagement_StatisticalAnalysis_SalespersonRelated = true;
                }
                if (r?.contains("FinancialManagement_StatisticalAnalysis_CustomerRelated"))
                {
                    this.FinancialManagement_StatisticalAnalysis_CustomerRelated = true;
                }

                
                if (r?.contains("FinancialManagement_StatisticalAnalysis_Overview_CollecionProgress")) {
                    this.FinancialManagement_StatisticalAnalysis_Overview_CollecionProgress = true;
                }
                if (r?.contains("FinancialManagement_StatisticalAnalysis_Overview_PaymentProgress")) {
                    this.FinancialManagement_StatisticalAnalysis_Overview_PaymentProgress = true;
                }
                if (r?.contains("FinancialManagement_StatisticalAnalysis_Overview_GrossProfit")) {
                    this.FinancialManagement_StatisticalAnalysis_Overview_GrossProfit = true;
                }
                if (r?.contains("FinancialManagement_StatisticalAnalysis_Overview_ActualProfit")) {
                    this.FinancialManagement_StatisticalAnalysis_Overview_ActualProfit = true;
                }
                if (r?.contains("FinancialManagement_StatisticalAnalysis_Overview_SalespersonPerformance")) {
                    this.FinancialManagement_StatisticalAnalysis_Overview_SalespersonPerformance = true;
                }
                if (r?.contains("FinancialManagement_StatisticalAnalysis_Overview_CustomerPerformance")) {
                    this.FinancialManagement_StatisticalAnalysis_Overview_CustomerPerformance = true;
                }

                this.type = this.$route.query.type as string;
                if (this.type == null || this.type == undefined || this.type == "") {
                    this.type = this.$route.query.Type as string;
                    if (this.type == null || this.type == undefined || this.type == "") {
                        if (this.FinancialManagement_StatisticalAnalysis_Overview_CollecionProgress == true) {
                            this.type = "0";
                        }
                        else if (this.FinancialManagement_StatisticalAnalysis_Overview_PaymentProgress == true) {
                            this.type = "1";
                        }
                        else if (this.FinancialManagement_StatisticalAnalysis_Overview_GrossProfit == true) {
                            this.type = "3";
                        }
                        else if (this.FinancialManagement_StatisticalAnalysis_Overview_ActualProfit == true) {
                            this.type = "4";
                        }
                        else if (this.FinancialManagement_StatisticalAnalysis_Overview_SalespersonPerformance == true) {
                            this.type = "2";
                        }
                        else if (this.FinancialManagement_StatisticalAnalysis_Overview_CustomerPerformance == true) {
                            this.type = "5";
                        }
                    }
                }
                this.isStat = false;
                this.onStat();
            });
        }
        //@Watch("month")
        //onMonthChanged(nv: any, ov: any): void {
        //    this.onStat();
        //}

        //@Watch("type")
        //onTypeChanged(): void {
        //    this.onStat();
        //}
        //onChangeType(type: string): void {
        //    this.type = type;
        //    this.$router.push(
        //        "/finance/stat/overview?type=" + type + "&month=" + this.month
        //    );
        //}

        //@Watch("month")
        //onMonthChanged(nv: any, ov: any): void {
        //    if (this.isInit == false) {
        //        this.onStat();
        //    }
        //}

        //@Watch("type")
        //onTypeChanged(): void {
        //    if (this.isInit == false) {
        //        this.onStat();
        //    }
        //}


        onChangeType(type: string): void {
            //this.type = type;

            if (type != "2") {
                if (this.isFinancialCycle == false) {
                    this.$router.push(
                        "/finance/stat/overview?type=" + type + "&month=" + this.month
                    );
                }
                else {
                    this.$router.push(
                        "/finance/stat/overview?type=" + type + "&month=" + this.month + "&isFinancialCycle=true"
                    );
                }
            }
            else {
                this.$router.push(
                    "/finance/stat/overview?type=" + type + "&month=" + this.month
                );
            }

            setTimeout(() => {
                
            this.items.Items = [];
            var items = DtoPageListItemOverviewSalerMiezzListItems?.filter(it=> this.currencySystem?.ShowTaxRate == true?true: !it.Prop?.contains("TaxAmount"))
            ?.filter(it=> this.type != "5"?true: (it.Prop != "PaymentString" && it.Prop != "ActualString"))
            ?.map((it) => {
                const item = Object.copy(it);
                if (item.Prop == "PaymentString") {
                    item.CustomizeHeader = true;
                    return item;
                }
                else if (item.Prop == "SalerName" && this.type == "5") {
                    item.Label = "客户名称";
                    return item;
                }
                else {
                    return item;
                }

            });
            if (items && this.items.Items) {
                for (var it of items) {
                    if (it != undefined) {
                        this.items.Items.push(it);
                    }
                }
            }
            }, 1);
            //this.onStat();
        }

        onTime(): void {
            if (this.isFinancialCycle == false) {
                this.$router.push(
                    "/finance/stat/overview?type=" + this.type + "&month=" + this.month + "&isFinancialCycle=true"
                );
            }
            else {
                this.$router.push(
                    "/finance/stat/overview?type=" + this.type + "&month=" + this.month + "&isFinancialCycle=false"
                );
            }
        }

        //监听路由是否有变化
        @Watch("$route")
        onRouteChanged(): void {
            if (this.isInit == false) {
                this.isInit = true;
                this.onStat();
            }
        }

        onDetail(
            type: number,
            currencyId: string | undefined,
            currencyCode: string,
            title: string
        ): void {
            this.detailForm.Visible = true;
            this.detailForm.Title = "组成";
            this.getChartPie(
                type,
                currencyId,
                "detailFormPie",
                title + "(币制：" + currencyCode + ")"
            );
        }

        onSumLink(): void {

            this.search = [];

            //this.search.push({
            //    Relation: EnumRelation.And,
            //    Where: {
            //        Prop: "DynamicSearch_SubmitStatus",
            //        Compare: EnumCompare.Equal,
            //        Value: "10",
            //    },
            //});
            var month = this.month;
            if (month != undefined && month?.indexOf(",") < 0) {
                month = month + "," + month;
            }

            var search = {
                Relation: EnumRelation.And,
                Where: {
                    Prop: "DynamicSearch_BusinessDate",
                    Compare: EnumCompare.Between,
                    Value: month,
                },
            };
            if (this.isFinancialCycle == true) {
                search = {
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_FinancialCycle",
                        Compare: EnumCompare.Between,
                        Value: month,
                    },
                };
            }
            DynamicSearchAppService.Post({
                Code: "FinancialManagement_BillSummary",
                Brackets: [
                    {
                        Relation: EnumRelation.And,
                        Items: [
                            search,
                        ],
                    },
                    {
                        Relation: EnumRelation.And,
                        Items: this.search,
                    },
                ],
            }).then((r) => {
                window.open(
                    `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                    "_blank"
                );
            });


        }

        onSettlement(): void {
            this.settlementVisible = true;
        }

        onSaler(row: any): void {
            window.open(
                `#/finance/stat/saler?Type=2&month=${this.month}&SalerId=${row.SalerId}&Channel=1`,
                "_blank"
            );
        }
        clearSearch(model: MiezzButton, complete: () => void):void{
            console.log("clearSearch");
            this.searchForm.CustomerName = "";
            this.onStat(model, complete);
        }
        onStat(model?: MiezzButton, complete?: () => void): void {
            if (complete) complete();
            //this.isStat = false;
            this.isFinancialCycle = false;
            var isFinancialCycle = this.$route.query.isFinancialCycle as string;
            if (isFinancialCycle == "true") {
                this.isFinancialCycle = true;
            }

            var type = this.$route.query.type as string;
            if (type == null || type == undefined || type == "") {
                type = this.$route.query.Type as string;
                if (type == null || type == undefined || type == "") {
                    if (this.FinancialManagement_StatisticalAnalysis_Overview_CollecionProgress == true) {
                        type = "0";
                    }
                    else if (this.FinancialManagement_StatisticalAnalysis_Overview_PaymentProgress == true) {
                        type = "1";
                    }
                    else if (this.FinancialManagement_StatisticalAnalysis_Overview_GrossProfit == true) {
                        type = "3";
                    }
                    else if (this.FinancialManagement_StatisticalAnalysis_Overview_ActualProfit == true) {
                        type = "4";
                    }
                    else if (this.FinancialManagement_StatisticalAnalysis_Overview_SalespersonPerformance == true) {
                        type = "2";
                    }
                        else if (this.FinancialManagement_StatisticalAnalysis_Overview_CustomerPerformance == true) {
                            this.type = "5";
                        }
                }
            }

            this.items.Items = [];
            var items = DtoPageListItemOverviewSalerMiezzListItems?.filter(it=> this.currencySystem?.ShowTaxRate == true?true: !it.Prop?.contains("TaxAmount"))
            ?.filter(it=> this.type != "5"?true: (it.Prop != "PaymentString" && it.Prop != "ActualString"))
            ?.map((it) => {
                const item = Object.copy(it);
                if (item.Prop == "PaymentString") {
                    item.CustomizeHeader = true;
                    return item;
                }
                else if (item.Prop == "SalerName" && this.type == "5") {
                    item.Label = "客户名称";
                    return item;
                }
                else {
                    return item;
                }

            });
            if (items && this.items.Items) {
                for (var it of items) {
                    if (it != undefined) {
                        this.items.Items.push(it);
                    }
                }
            }

            var month = this.$route.query.month as string;
            if (month == null || month == undefined || month == "") {
                month = this.$route.query.Month as string;
            }

            this.isStat = true;
            if (type != this.type || month != this.month || this.isInit == true) {
                this.type = type;
                this.month = month;
                this.isStat = false;
            }

            if (model) this.isStat = false;
            if (this.isStat == false) {
                this.isStat = true;
      
          

                //if (this.type == "3") {
                //    this.onGrossProfitStat();
                //}

                if (this.type != "2" && this.type != "5") {
                    var param = new DtoRequestCount();
                    param.Month = this.month;
                    param.Channel = 0;
                    if (this.type == "") {
                        this.type = "0";
                    }
                    param.Type = Number(this.type);
                    this.isLoading = true;
                    param.IsFinancialCycle = this.isFinancialCycle;
                    FinanceAppService.Count(param).then((r) => {
                        this.isLoading = false;
                        this.isStat = false;
                        if (r.data.Data) {
                            this.result = r.data.Data;
                            if (this.type == "3") {
                                this.onGrossProfitStat(this.result.GrossProfit);
                            }
                        } 
                        this.isInit = false;
                 
                    });
                }
                else {
                    this.isLoading = true;

                    if (this.items.Dto) {
                        // this.items.Dto.Month = this.month;
                        this.items.Dto.Channel = 1;
                        this.items.Dto.Type = Number(this.type);
                        this.items.Dto.SalerId = undefined;
                        this.items.Dto.CompanyId = undefined;
                        this.items.Dto.companyId = undefined;
                        this.items.Dto.month = this.month;
                        this.items.Dto.IsFinancialCycle = this.isFinancialCycle;
                        this.items.Dto.CustomerName = this.searchForm.CustomerName;
                        this.items.Dto.SalerName = this.searchForm.CustomerName;
                        //this.items.Dto.month = this.month;
                    }
                    if (this.type == "2") {
                    FinanceAppService.GetOverviewSalerBill(this.items.Dto).then((r) => {
                        this.isLoading = false;
                        this.isStat = false;
                        if (r.data.Data) this.items.Data = r.data.Data;
                        this.isInit = false;

                    })
                    }else {
                    FinanceAppService.GetOverviewCustomerBill(this.items.Dto).then((r) => {
                        this.isLoading = false;
                        this.isStat = false;
                        if (r.data.Data) this.items.Data = r.data.Data;
                        this.isInit = false;

                    })
                    }
                }
            }

        }

        onChangeChannel(type: string): void {
            if (type == "0") {
                this.$router.push("/finance/stat/overview");
            } else if (type == "1") {
                this.$router.push("/finance/stat/saler");
            } else if (type == "2") {
                this.$router.push("/finance/stat/customer");
            }
        }

        CompositionType = 0;
        getChartPie(
            type: number,
            currencyId: string | undefined,
            ref: string,
            title: string
        ): void {
            var param = new DtoRequestCount();
            param.Month = this.month;
            param.Channel = 0;
            param.CurrencySystemId = currencyId;
            if (this.type == "") {
                this.type = "0";
            }
            param.CompositionType = type;
           
            param.Type = Number(this.type);
            this.CompositionType = type;
            this.isLoading = true;
            if (this.isFinancialCycle == true) {
                param.IsFinancialCycle = true;
            }
            else {
                param.IsFinancialCycle = false;
            }
            FinanceAppService.Composition(param).then((r) => {
                this.isLoading = false;
                if (r.data.Data) {
                    this.detail = r.data.Data;
                    this.detailForm.Items = r.data.Data.Items ?? [];
                    this.detailForm.Details = r.data.Data.Details ?? [];
                    this.detailForm.CurrentSystemId = r.data.Data.CurrencySystemId;
                    const option: EChartsOption = {
                        title: {
                            text: title,
                            left: "center",
                            textStyle: {
                                color: "#666",
                            },
                        },
                        tooltip: {
                            trigger: "item",
                        },
                        legend: {
                            orient: "vertical",
          left: "left",
          top: "30px"
                        },
                        series: [
                            {
                                type: "pie",
                                radius: "50%",
                                label: {
                                    show: false,
                                },
                                data: r.data.Data?.SeriesData,
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: "rgba(0, 0, 0, 0.5)",
                                    },
                                },
                            },
                        ],
                    };
                    this.initChart(ref, option);
                }
            });
        }

        onClientCompany(row: any) {
            window.open(
                "/#/customer/company/credit-and-accounting-period/" + row.ClientCompanyId,
                "_blank"
            );
        }
        onGrossProfitStat(row: any): void {
            console.log(row);
    var formatNumber = (num?: number) => {
        if (!num) return '';
        // 去除非数字字符（保留负号和小数点）
        const cleanNum = num.toString().replace(/[^\d.-]/g, '');
        // 分割整数和小数部分
        const parts = cleanNum.split('.');
        // 整数部分加千分位
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // 拼接整数和小数部分
        return parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];
    };
            const option: EChartsOption = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ['line', 'bar', 'bar', 'bar', 'stack'] },
                        restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                legend: {
                    data: ['毛利润','应收','应付','应收坏账','应付坏账','毛利率']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: row.Months,
                        axisPointer: {
                            type: 'shadow'
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '毛利润',
                        min: row.MinPrice,
                        max: row.MaxPrice,
                        interval: row.IntervalPrice,
                        axisLabel: {
                            formatter: '{value} 元'
                        },

                    },
                    {
                        type: 'value',
                        name: '毛利率',
                        min: row.MinPoint,
                        max: row.MaxPoint,
                        interval: row.IntervalPoint,
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }
                ],
                series: [
                    {
                        name: '毛利润',
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return formatNumber(value as number) + ' 元';
                            }
                        },
                        data: row.Price,
                        barMaxWidth: 50
                    },
                    {
                        name: '应收',
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return formatNumber(value as number) + ' 元';
                            }
                        },
                        data: row.Collection,
                        barMaxWidth: 50
                    },
                    {
                        name: '应付',
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return formatNumber(value as number) + ' 元';
                            }
                        },
                        data: row.Payment,
                        barMaxWidth: 50
                    },
                    {
                        name: '应收坏账',
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return formatNumber(value as number) + ' 元';
                            }
                        },
                        data: row.BadCollectionSettlement,
                        barMaxWidth: 50
                    },
                    {
                        name: '应付坏账',
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return formatNumber(value as number) + ' 元';
                            }
                        },
                        data: row.BadPaymentSettlement,
                        barMaxWidth: 50
                    },
                    {
                        name: '毛利率',
                        type: 'line',
                        yAxisIndex: 1,
                        tooltip: {
                            valueFormatter: function (value) {
                                return formatNumber(value as number) + ' %';
                            }
                        },
                        data: row.Point,
                    }
                ]
            };
            var ref = "divGrossProfitChart";
            this.onGrossProfitChart(ref, option);
        }
        onGrossProfitChart(ref: string, option: EChartsOption): void {
            this.isGrossProfitChart = true;
            this.$nextTick(() => {
                const element = this.$refs[ref] as InstanceType<typeof HTMLElement>;
                if (element) {
                    const echarts = init(element);
                    echarts.setOption(option);
                }
            });
        }

        onClientDetail(row: any): void {
            this.left = [];
            this.right = [];

            var month = this.month;
            if (this.month?.indexOf(",") == -1) {
                month = this.month + "," + this.month;
            }
            if (this.isFinancialCycle == false) {
                this.left.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_BusinessDate",
                        Compare: EnumCompare.Between,
                        Value: month,
                    },
                });
            }
            else {
                this.left.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_FinancialCycle",
                        Compare: EnumCompare.Between,
                        Value: month,
                    },
                });
            }


            if (this.CompositionType == 8) {
                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_IsBad",
                        Compare: EnumCompare.Equal,
                        Value: "10",
                    },
                });
            }

            if (this.CompositionType == 1) {
                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_InvoiceState",
                        Compare: EnumCompare.NoEqual,
                        Value: "10",
                    },
                });
            }
            else if (this.CompositionType == 2) {
                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_InvoiceState",
                        Compare: EnumCompare.NoEqual,
                        Value: "30",
                    },
                });
            }
            else if (this.CompositionType == 3) {
                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_SettlementType",
                        Compare: EnumCompare.NoEqual,
                        Value: "10",
                    },
                });
            }
            else if (this.CompositionType == 4) {
                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_SettlementType",
                        Compare: EnumCompare.NoEqual,
                        Value: "30",
                    },
                });
            }
            else if (this.CompositionType == 5) {
                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_OverdueStatus",
                        Compare: EnumCompare.Equal,
                        Value: "10",
                    },
                });

                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_SettlementType",
                        Compare: EnumCompare.NoEqual,
                        Value: "10",
                    },
                });
            }
            else if (this.CompositionType == 6) {
                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_OverdueStatus",
                        Compare: EnumCompare.Equal,
                        Value: "10",
                    },
                });

                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_SettlementType",
                        Compare: EnumCompare.NoEqual,
                        Value: "30",
                    },
                });
            }



            if (row.Name.indexOf("未分摊") < 0) {

                if (row.Type == 0) {
                    this.left.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: "10",
                        },
                    });


                }
                else if (row.Type == 1) {
                    this.left.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: "20",
                        },
                    });
                }

                if (row.Type == 3) {
                    this.left.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_ClientCompany",
                            Compare: EnumCompare.Equal,
                            Value: row.CompanyId,
                        },
                    });
                }
                else {
                    this.left.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Object",
                            Compare: EnumCompare.Equal,
                            Value: row.Name,
                        },
                    });
                }






                //this.right.push({
                //    Relation: EnumRelation.And,
                //    Where: {
                //        Prop: "DynamicSearch_SubmitStatus",
                //        Compare: EnumCompare.Equal,
                //        Value: "10",
                //    },
                //});

                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_CurrencySystem",
                        Compare: EnumCompare.Equal,
                        Value: this.detailForm.CurrentSystemId,
                    },
                });

                DynamicSearchAppService.Post({
                    Code: "FinancialManagement_BillSummary",
                    Brackets: [
                        {
                            Relation: EnumRelation.And,
                            Items: this.left,
                        },
                        {
                            Relation: EnumRelation.And,
                            Items: this.right,
                        },
                    ],
                }).then((r) => {
                    if (row.Type == 3) {
                        window.open(
                            `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                            "_blank"
                        );
                    }
                    else {
                        window.open(
                            `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                            "_blank"
                        );
                    }

                });
            }
            else {
                this.left.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_ShareStatus",
                        Compare: EnumCompare.Equal,
                        Value: "10",
                    },
                });

                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_CurrencySystem",
                        Compare: EnumCompare.Equal,
                        Value: this.detailForm.CurrentSystemId,
                    },
                });

                //this.right.push({
                //    Relation: EnumRelation.And,
                //    Where: {
                //        Prop: "DynamicSearch_SubmitStatus",
                //        Compare: EnumCompare.Equal,
                //        Value: "10",
                //    },
                //});

                DynamicSearchAppService.Post({
                    Code: "FinancialManagement_BillSummary",
                    Brackets: [
                        {
                            Relation: EnumRelation.And,
                            Items: this.left,
                        },
                        {
                            Relation: EnumRelation.And,
                            Items: this.right,
                        },
                    ],
                }).then((r) => {
                    if (row.Type == 3) {
                        window.open(
                            `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                            "_blank"
                        );
                    }
                    else {
                        window.open(
                            `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                            "_blank"
                        );
                    }

                });
            }

        }

        initChart(ref: string, option: EChartsOption): void {
            this.$nextTick(() => {
                const element = this.$refs[ref] as InstanceType<typeof HTMLElement>;
                if (element) {
                    const echarts = init(element);
                    echarts.setOption(option);
                }
            });
        }
        isString(str: string, row: any | undefined): string {
            if (row != undefined && row != null) {
                if (row.FromId == undefined || row.FromId == null) {
                    if (str == null || str == undefined || str == "") {
                        return "暂无数据";
                    }
                    else {
                        return str;
                    }
                }
                else {
                    if (str == null || str == undefined || str == "") {
                        return "—";
                    }
                    else {
                        return str;
                    }
                }
            }
            else {
                if (str == null || str == undefined || str == "") {
                    return "暂无数据";
                }
                else {
                    return str;
                }
            }
        }

        onPool(row: any): void {

            if (row.PoolId != undefined && row.PoolId != null && row.PoolId != "") {
                window.open(
                    `#/pool/bill/${row.PoolId}`,
                    "_blank"
                );
            }

            //this.left = [];
            //this.right = [];


            //if (row.PoolId != null && row.PoolId != undefined && row.PoolId != "") {
            //    this.left.push({
            //        Relation: EnumRelation.And,
            //        Where: {
            //            Prop: "DynamicSearch_Pool",
            //            Compare: EnumCompare.Contain,
            //            Value: row.BookingNo,
            //        },
            //    });

            //    DynamicSearchAppService.Post({
            //        Code: "FinancialManagement_BillSummary",
            //        Brackets: [
            //            {
            //                Relation: EnumRelation.And,
            //                Items: this.left,
            //            },
            //            {
            //                Relation: EnumRelation.And,
            //                Items: this.right,
            //            },
            //        ],
            //    }).then((r) => {
            //        window.open(
            //            `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
            //            "_blank"
            //        );
            //    });
            //}
            //else {
            //    this.left.push({
            //        Relation: EnumRelation.And,
            //        Where: {
            //            Prop: "DynamicSearch_ShareStatus",
            //            Compare: EnumCompare.Equal,
            //            Value: "10",
            //        },
            //    });

            //    var month = this.month;
            //    if (this.month?.indexOf(",") == -1) {
            //        month = this.month + "," + this.month;
            //    }
            //    if (this.isFinancialCycle == false) {
            //        this.left.push({
            //            Relation: EnumRelation.And,
            //            Where: {
            //                Prop: "DynamicSearch_BusinessDate",
            //                Compare: EnumCompare.Between,
            //                Value: month,
            //            },
            //        });
            //    }
            //    else {
            //        this.left.push({
            //            Relation: EnumRelation.And,
            //            Where: {
            //                Prop: "DynamicSearch_FinancialCycle",
            //                Compare: EnumCompare.Between,
            //                Value: month,
            //            },
            //        });
            //    }
       


            //    DynamicSearchAppService.Post({
            //        Code: "FinancialManagement_BillSummary",
            //        Brackets: [
            //            {
            //                Relation: EnumRelation.And,
            //                Items: this.left,
            //            },
            //            {
            //                Relation: EnumRelation.And,
            //                Items: this.right,
            //            },
            //        ],
            //    }).then((r) => {
            //        window.open(
            //            `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
            //            "_blank"
            //        );
            //    });
            //}

        }

        onBill(type: string, currency: string) {
            this.left = [];
            this.right = [];
            var month = this.month;
            if (this.month?.indexOf(",") == -1) {
                month = this.month + "," + this.month;
            }
            if (this.isFinancialCycle == false) {
                this.left.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_BusinessDate",
                        Compare: EnumCompare.Between,
                        Value: month,
                    },
                });
            }
            else {
                this.left.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_FinancialCycle",
                        Compare: EnumCompare.Between,
                        Value: month,
                    },
                });
            }
  
            this.left.push({
                Relation: EnumRelation.And,
                Where: {
                    Prop: "DynamicSearch_CurrencySystem",
                    Compare: EnumCompare.Equal,
                    Value: currency,
                },
            });


            if (this.type == "3") {
                if (type == "1") {
                    //利润
                    //this.left.push({
                    //    Relation: EnumRelation.And,
                    //    Where: {
                    //        Prop: "DynamicSearch_SubmitStatus",
                    //        Compare: EnumCompare.Equal,
                    //        Value: "10",
                    //    },
                    //});

                    this.right.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: "10",
                        },
                    });
                    this.right.push({
                        Relation: EnumRelation.Or,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: "20",
                        },
                    });
                }
                else if (type == "2") {
                    //应收款
                    //this.right.push({
                    //    Relation: EnumRelation.And,
                    //    Where: {
                    //        Prop: "DynamicSearch_SubmitStatus",
                    //        Compare: EnumCompare.Equal,
                    //        Value: "10",
                    //    },
                    //});

                    this.right.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: "10",
                        },
                    });
                }
                else if (type == "3") {
                    //应付款
                    //this.right.push({
                    //    Relation: EnumRelation.And,
                    //    Where: {
                    //        Prop: "DynamicSearch_SubmitStatus",
                    //        Compare: EnumCompare.Equal,
                    //        Value: "10",
                    //    },
                    //});
                    this.right.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: "20",
                        },
                    });
                }
            }
            else if (this.type == "4") {
                //this.left.push({
                //    Relation: EnumRelation.And,
                //    Where: {
                //        Prop: "DynamicSearch_SubmitStatus",
                //        Compare: EnumCompare.Equal,
                //        Value: "10",
                //    },
                //});
                this.right.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_SettlementType",
                        Compare: EnumCompare.Equal,
                        Value: "20",
                    },
                });
                this.right.push({
                    Relation: EnumRelation.Or,
                    Where: {
                        Prop: "DynamicSearch_SettlementType",
                        Compare: EnumCompare.Equal,
                        Value: "30",
                    },
                });
                if (type == "2") {
                    //应收已核销
                    this.right.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: "10",
                        },
                    });
                }
                else if (type == "3") {
                    //应付已核销
                    this.right.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: "20",
                        },
                    });
                }
            }

            DynamicSearchAppService.Post({
                Code: "FinancialManagement_BillSummary",
                Brackets: [
                    {
                        Relation: EnumRelation.And,
                        Items: this.left,
                    },
                    {
                        Relation: EnumRelation.And,
                        Items: this.right,
                    },
                ],
            }).then((r) => {
                window.open(
                    `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                    "_blank"
                );
            });
        }
        onNoBill(): void {
            var date = {
                Relation: EnumRelation.And,
                Where: {
                    Prop: "DynamicSearch_BusinessCycle",
                    Compare: EnumCompare.Between,
                    Value: this.month,
                },
            };
            if (this.isFinancialCycle == true) {
                date = {
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_FinancialCycle",
                        Compare: EnumCompare.NoBetween,
                        Value: this.month,
                    },
                };
            }
            var leftSearch = [];
            var rightSearch = [];
            leftSearch.push(date);

            //DynamicSearch_CollectionSubmitStatus
            if (this.type == "" || this.type == "0") {
                rightSearch.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_CollectionSubmitStatus",
                        Compare: EnumCompare.Equal,
                        Value: "1",
                    },
                });
            }
            else {
                rightSearch.push({
                    Relation: EnumRelation.And,
                    Where: {
                        Prop: "DynamicSearch_PaymentSubmitStatus",
                        Compare: EnumCompare.Equal,
                        Value: "1",
                    },
                });
            }


            DynamicSearchAppService.Post({
                Code: "FinancialManagement_BillSummary",
                Brackets: [
                    {
                        Relation: EnumRelation.And,
                        Items: leftSearch,
                    },
                    {
                        Relation: EnumRelation.And,
                        Items: rightSearch,
                    },
                ],
            }).then((r) => {
                window.open(
                    `#/order/pool?IsStat=true&DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                    "_blank"
                );
            });
        }
        handleClickDetail(btn: MiezzButton, complete: () => void): void {
            switch (btn.Code) {
                case "submit":
                    this.search = [];

           


                    if (this.detail.Search?.SettlementType == "30") {
                        this.search = [{
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_SettlementType",
                                Compare: EnumCompare.Equal,
                                Value: "20",
                            },
                        },
                        {
                            Relation: EnumRelation.Or,
                            Where: {
                                Prop: "DynamicSearch_SettlementType",
                                Compare: EnumCompare.Equal,
                                Value: "30",
                            },
                        }
                        ];
                    }
                    else if (this.detail.Search?.SettlementType == "10") {
                        this.search = [{
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_SettlementType",
                                Compare: EnumCompare.Equal,
                                Value: "10",
                            },
                        },
                        {
                            Relation: EnumRelation.Or,
                            Where: {
                                Prop: "DynamicSearch_SettlementType",
                                Compare: EnumCompare.Equal,
                                Value: "20",
                            },
                        }
                        ];
                    }
                    else if (this.detail.Search?.SettlementType == "99999") {
                        this.search = [{
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_IsBad",
                                Compare: EnumCompare.Equal,
                                Value: "10",
                            },
                        },
                        ];
                    }

                    if (this.detail.Search?.OverdueType == "10") {
                        this.search.push({
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_OverdueStatus",
                                Compare: EnumCompare.Equal,
                                Value: "10",
                            },
                        });
                    }

                    //this.search.push({
                    //    Relation: EnumRelation.And,
                    //    Where: {
                    //        Prop: "DynamicSearch_SubmitStatus",
                    //        Compare: EnumCompare.Equal,
                    //        Value: "10",
                    //    },
                    //});


                    var date = {
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_BusinessDate",
                            Compare: EnumCompare.Between,
                            Value: this.detail.Search?.Month,
                        },
                    };
                    if (this.isFinancialCycle == true) {
                        date = {
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_FinancialCycle",
                                Compare: EnumCompare.Between,
                                Value: this.detail.Search?.Month,
                            },
                        };
                    }
                    var left = [];
                    left.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_CurrencySystem",
                            Compare: EnumCompare.Equal,
                            Value: this.detail.Search?.CurrencySystemId,
                        },
                    });

                    left.push({
                        Relation: EnumRelation.And,
                        Where: {
                            Prop: "DynamicSearch_Type",
                            Compare: EnumCompare.Equal,
                            Value: this.detail.Search?.Type,
                        },
                    });
                    if (this.CompositionType == 1) {
                        left.push({
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_InvoiceState",
                                Compare: EnumCompare.NoEqual,
                                Value: "10",
                            },
                        });
                    }
                    else if (this.CompositionType == 2) {
                        left.push({
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_InvoiceState",
                                Compare: EnumCompare.NoEqual,
                                Value: "30",
                            },
                        });
                    }


                    var month = this.month;
                    if (this.month?.indexOf(",") == -1) {
                        month = this.month + "," + this.month;
                    }
                    if (this.isFinancialCycle == false) {
                        this.search.push({
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_BusinessDate",
                                Compare: EnumCompare.Between,
                                Value: month,
                            },
                        });
                    }
                    else {
                        this.search.push({
                            Relation: EnumRelation.And,
                            Where: {
                                Prop: "DynamicSearch_FinancialCycle",
                                Compare: EnumCompare.Between,
                                Value: month,
                            },
                        });
                    }

                    DynamicSearchAppService.Post({
                        Code: "FinancialManagement_BillSummary",
                        Brackets: [
                            {
                                Relation: EnumRelation.And,
                                Items: left,
                            },
                            {
                                Relation: EnumRelation.And,
                                Items: this.search,
                            },
                        ],
                    }).then((r) => {
                        window.open(
                            `#/finance/bill?DynamicSearchId=${r.data.Data}&OpenSearch=true`,
                            "_blank"
                        );
                        complete();
                    });
                    complete();
                    break;
                case "close":
                    this.detailForm.Visible = false;
                    complete();
                    break;
                default:
                    break;
            }
        }

        onGrossProfitDetail(): void {
            if (this.grossProfitDetailForm) {
                this.grossProfitDetailForm.Visible = true;
            }
        }
        handleClickGrossProfitDetail(btn: MiezzButton, complete: () => void): void {
            switch (btn.Code) {
                case "export":
                    this.isLoading = true;
                    FinanceAppService.StatPoolExport(this.result).then((r) => {
                        this.isLoading = false;
                        window.open(process.env.VUE_APP_BASE_URL + r.data.Data, "_blank");
                        complete();
                    })
                    break;
                case "close":
                    this.grossProfitDetailForm.Visible = false;
                    complete();
                    break;
                default:
                    break;
            }
        }

        handleClickSettlementDetail(btn: MiezzButton, complete: () => void): void {
            switch (btn.Code) {
                case "close":
                    this.settlementVisible = false;
                    complete();
                    break;
                default:
                    break;
            }
        }
    }

    /*仅允许输入数字，其他字符都去除 */
    /*val：输入的字符串 */
    /*num：小数点后保留几位小数 */
    /*isZero：是否允许输入0 */
    /*isLessZero：是否允许输入小于0 */
    var setDecimal = function (
        val: string,
        num: number,
        isZero: boolean,
        isLessZero: boolean
    ) {
        var str = val;
        if (val == null || val == undefined || val == "") {
            return "";
        }

        if (val != null && val != "") {
            val = val.toString();
            val = val.replace(/[^\d.]/g, "");
            val = val.replace(/\.{2,}/g, ".");
            val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            val = val.replace(/^(\\-)*(\d+)\.(\d\d\d\d\d\d\d\d\d).*$/, "$1$2.$3"); //最多输入2个小数
            if (val.indexOf(".") < 0 && val != "") {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                val = parseFloat(val).toString();
            }
            if (isLessZero == true) {
                if (str[0] == "-") {
                    val = "-" + val;
                }
            }
        }

        if (val == "" || val == undefined || val.toString() == "NaN") {
            val = "";
            return val;
        }

        if (isZero == true) {
            if (parseFloat(val.toString()) == 0) {
                return val;
            }
        } else {
            if (parseFloat(val.toString()) == 0) {
                return "";
            }
        }
        if (val.toString() == "NaN") {
            val = "";
            return val;
        }

        var point = "1";
        for (var i = 0; i < num; i++) {
            point += "0";
        }
        var result =
            Math.round((Number(val) + Number.EPSILON) * Number(point)) / Number(point) +
            "";
        //var result = parseFloat(val).toRound(num);
        if (isZero == false && result == "0") {
            return "";
        } else {
            return result;
        }
    };

    //去除特殊字符~!@#$^-&*()=|{}':;',\[].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？
    function trimSpecial(str: string) {
        var name = "";
        if (str != undefined && str != "") {
            str = str.replace(/[\u4e00-\u9fa5]/g, "");
            for (var i = 0; i < str.length; i++) {
                if (str[i] == "　") {
                    name += " ";
                } else {
                    name += str[i];
                }
            }
            //全角空格转换成半角空格
            str = name;
            name = "";

            for (var j = 0; j < str.length; j++) {
                //if (str[j] != " " && str[j] != "~" && str[j] != "!" && str[j] != "@"
                //    && str[j] != "#" && str[j] != "$" && str[j] != "^"
                //    && str[j] != "-" && str[j] != "&" && str[j] != "*"
                //    && str[j] != "(" && str[j] != ")" && str[j] != "="
                //    && str[j] != "|" && str[j] != "{" && str[j] != "}"
                //    && str[j] != "'" && str[j] != ":" && str[j] != "'"
                //    && str[j] != "," && str[j] != "\\" && str[j] != "["
                //    && str[j] != "]" && str[j] != "." && str[j] != "<"
                //    && str[j] != ">" && str[j] != "/" && str[j] != "?"
                //    && str[j] != "~" && str[j] != "！" && str[j] != "@"
                //    && str[j] != "#" && str[j] != "￥" && str[j] != "…"
                //    && str[j] != "&" && str[j] != "*" && str[j] != "（"
                //    && str[j] != "）" && str[j] != "—" && str[j] != "|"
                //    && str[j] != "{" && str[j] != "}" && str[j] != "【"
                //    && str[j] != "】" && str[j] != "'" && str[j] != "；"
                //    && str[j] != "：" && str[j] != "\"" && str[j] != "\""
                //    && str[j] != "'" && str[j] != "。" && str[j] != "，"
                //    && str[j] != "、" && str[j] != "？"
                //) {
                //    name += str[j];
                //}
                if (str[j] != " ") {
                    name += str[j];
                }
            }

            str = str.replace(/[\u00A0-\u00FF]|[\u0100-\u017F]|[\u0180-\u024F]/g, "?");
            //替换罗马数字到千位
            str = str.replace(
                /(?=[MDCLXVI])M*(C[MD]|D?C{0,3})(X[CL]|L?X{0,3})(I[XV]|V?I{0,3})$/g,
                "?"
            );
            //罗马1-9个数位限制和整数位
            str = str.replace(/[\u2160-\u2183]/g, "?");
            //替换中文标点符号
            str = str.replace(
                /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/g,
                "?"
            );
        }
        return name;
    }
